import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
    const { t } = useTranslation();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-brand">
                            <div className="brand-logo">
                                <div className="logo-icon">⚕️</div>
                                <span className="brand-text">
                                    <span className="brand-name">{t('footer.brand.name')}</span>
                                    <span className="brand-tagline">{t('footer.brand.tagline')}</span>
                                </span>
                            </div>
                        </div>
                        <p className="footer-description">
                            {t('footer.description')}
                        </p>
                        <div className="social-links">
                            <a href="#" aria-label="Facebook" className="social-link">
                                <Facebook size={20} />
                            </a>
                            <a href="#" aria-label="Twitter" className="social-link">
                                <Twitter size={20} />
                            </a>
                            <a href="#" aria-label="Instagram" className="social-link">
                                <Instagram size={20} />
                            </a>
                            <a href="#" aria-label="LinkedIn" className="social-link">
                                <Linkedin size={20} />
                            </a>
                        </div>
                    </div>
                    <div className="footer-section">
                        <h3 className="footer-title">{t('footer.quickLinks')}</h3>
                        <ul className="footer-links">
                            <li>
                                <a href="#home">{t('footer.links.home')}</a>
                            </li>
                            <li>
                                <a href="#services">{t('footer.links.services')}</a>
                            </li>
                            <li>
                                <a href="#about">{t('footer.links.about')}</a>
                            </li>
                            <li>
                                <a href="#testimonials">{t('footer.links.testimonials')}</a>
                            </li>
                            <li>
                                <a href="#contact">{t('footer.links.contact')}</a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3 className="footer-title">{t('services.title')}</h3>
                        <ul className="footer-links">
                            <li>
                                <a href="#services">{t('services.items.cardiology.title')}</a>
                            </li>
                            <li>
                                <a href="#services">{t('services.items.neurology.title')}</a>
                            </li>
                            <li>
                                <a href="#services">{t('services.items.general.title')}</a>
                            </li>
                            <li>
                                <a href="#services">{t('services.items.laboratory.title')}</a>
                            </li>
                            <li>
                                <a href="#services">{t('services.items.pharmacy.title')}</a>
                            </li>
                            <li>
                                <a href="#services">{t('services.items.preventive.title')}</a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3 className="footer-title">{t('footer.contact')}</h3>
                        <ul className="footer-contact">
                            <li>
                                <Phone size={18} />
                                <span>{t('footer.phoneValue')}</span>
                            </li>
                            <li>
                                <Mail size={18} />
                                <span>{t('footer.emailValue')}</span>
                            </li>
                            <li>
                                <MapPin size={18} />
                                <span>{t('footer.addressValue')}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
                    <div className="footer-bottom-links">
                        <a href="#">{t('footer.privacy')}</a>
                        <a href="#">{t('footer.terms')}</a>
                    </div>
                    <p className="techplanes-credit">
                        Built By <a href="https://techplanes.com" target="_blank" rel="noopener noreferrer">TechPlanes.com</a>
                    </p>
                    <button className="scroll-top" onClick={scrollToTop}>
                        ↑
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

